import { useState } from "react";
import { Button } from "../ui/button";
import { toast } from "sonner";

const ABILITIES = ["str", "dex", "con", "int", "wis", "cha"];
const LABELS = { str: "STR", dex: "DEX", con: "CON", int: "INT", wis: "WIS", cha: "CHA" };

// Auto-Leveling Engine: surfaces a pending 5e Ability Score Improvement (levels 4/8/12/16/19) —
// HP was already auto-applied server-side; this just resolves the +2/one or +1/two choice.
export default function Dnd5eAsiPanel({ character, patch }) {
  const dnd = character.dnd5e || {};
  const levels = dnd.pending_asi_levels || [];
  const [mode, setMode] = useState(null); // "plus2" | "plus1plus1"
  const [picked, setPicked] = useState([]);
  if (levels.length === 0) return null;
  const level = levels[0];

  const pick = (ability) => {
    if (picked.includes(ability)) return setPicked(picked.filter((a) => a !== ability));
    const max = mode === "plus2" ? 1 : 2;
    if (picked.length >= max) return;
    setPicked([...picked, ability]);
  };

  const confirm = async () => {
    const abilities = { ...character.abilities };
    const history = [...(character.boost_history || [])];
    const amount = mode === "plus2" ? 2 : 1;
    for (const a of picked) {
      abilities[a] = (abilities[a] || 10) + amount;
      history.push({ source: `asi_level_${level}`, ability: a, amount });
    }
    await patch({ abilities, boost_history: history, dnd5e: { ...dnd, pending_asi_levels: levels.slice(1) } });
    toast.success(`Level ${level} Ability Score Improvement applied!`);
    setMode(null);
    setPicked([]);
  };

  const ready = (mode === "plus2" && picked.length === 1) || (mode === "plus1plus1" && picked.length === 2);

  return (
    <div className="rounded-2xl border border-[#D4AF37]/40 bg-[#D4AF37]/5 p-4 space-y-2" data-testid="dnd5e-asi-panel">
      <p className="text-xs uppercase tracking-widest text-[#D4AF37]">Level {level} — Ability Score Improvement</p>
      {!mode ? (
        <div className="flex gap-2">
          <Button data-testid="asi-mode-plus2" size="sm" variant="secondary" className="rounded-full flex-1" onClick={() => setMode("plus2")}>+2 to one ability</Button>
          <Button data-testid="asi-mode-plus1plus1" size="sm" variant="secondary" className="rounded-full flex-1" onClick={() => setMode("plus1plus1")}>+1 to two abilities</Button>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-3 gap-2">
            {ABILITIES.map((a) => (
              <button key={a} type="button" data-testid={`asi-pick-${a}`} onClick={() => pick(a)}
                className={`text-xs px-2 py-2 rounded-lg border transition-colors duration-200 ${picked.includes(a) ? "border-[#D4AF37] text-[#D4AF37]" : "border-white/10 hover:border-[#D4AF37]/50"}`}>
                {LABELS[a]}
              </button>
            ))}
          </div>
          <Button data-testid="asi-confirm-button" disabled={!ready} className="w-full rounded-full bg-[#D90429] hover:bg-[#b8031f]" onClick={confirm}>Confirm</Button>
        </>
      )}
    </div>
  );
}
